import React from "react";

interface Props {
  smallLogo?: boolean;
}

const HeaderLogoMobile = (props: Props) => {
  return (
    <svg
      width="18"
      height="55"
      viewBox="0 0 10 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ margin: "auto" }}
    >
      <g clipPath="url(#clip0)">
        <mask
          id="mask0"
          mask-type="alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="12"
          height="38"
        >
          <path
            d="M4.73495 2.44385C4.04837 3.30251 3.70504 4.55049 3.70504 6.18469V11.0765H1.44443V12.9123H3.70504V30.7268C3.70504 31.7864 3.47844 32.628 3.02788 33.2487C2.3617 34.1798 1.35284 34.6544 0 34.6736V36.4803C2.12183 36.4714 3.6993 35.8236 4.73495 34.5356C5.42144 33.6766 5.76477 32.4299 5.76477 30.796V12.9123H9.46801V11.0765H5.76477V5.48792C5.76477 4.42761 6.10835 3.90294 6.63592 3.36279C7.41106 2.56906 8.12655 2.3257 9.46801 2.30729V0.5C7.34773 0.507591 5.76928 1.15649 4.73495 2.44385Z"
            fill="#444443"
          />
        </mask>
        <g mask="url(#mask0)">
          <g filter="url(#filter0_f)">
            <path
              d="M-5.57063 -4.76096C-1.27941 -4.76096 3.01181 -4.76096 7.30304 -4.76096C7.3004 0.697646 7.29775 5.40272 7.29512 10.0401C3.01853 10.8137 -1.24634 11.7853 -5.57063 11.7479C-5.57063 6.24498 -5.57063 0.742012 -5.57063 -4.76096Z"
              fill="#FFFFFF"
            />
            <path
              d="M7.30304 -4.76096C10.1856 -4.76096 13.0682 -4.76096 15.9508 -4.76096C15.9508 0.742012 15.9508 4.98529 15.9508 9.11544C13.0459 9.09032 10.1679 9.52052 7.29512 10.0401C7.29776 5.40272 7.3004 0.697646 7.30304 -4.76096Z"
              fill="#FFFFFF"
            />
            <path
              d="M-5.57063 11.7479C-1.24634 11.7853 3.01853 10.8137 7.29511 10.0401C7.29428 11.4993 7.29345 12.9517 7.29262 14.4189C3.02064 15.5286 -1.23594 16.8988 -5.57063 16.9425C-5.57063 15.211 -5.57063 13.4795 -5.57063 11.7479Z"
              fill="#FFFFFF"
            />
            <path
              d="M7.2951 10.0402C10.1678 9.52054 13.0459 9.09034 15.9507 9.11546C15.9507 10.415 15.9507 11.7034 15.9507 13.0162C13.0388 13.0455 10.1622 13.6734 7.2926 14.4189C7.29343 12.9518 7.29427 11.4993 7.2951 10.0402H7.2951Z"
              fill="#FFFFFF"
            />
            <path
              d="M-5.57063 16.9425C-1.9474 16.906 1.62125 15.9427 5.18994 14.9793C5.18994 16.6388 4.90157 18.3293 4.54896 20.0611C1.27843 21.3088 -1.99207 22.5564 -5.57063 22.6056C-5.57063 20.7179 -5.57063 18.8302 -5.57063 16.9425Z"
              fill="#FFFFFF"
            />
            <path
              d="M-5.57063 22.6056C-1.99208 22.5564 1.27843 21.3088 4.54896 20.0612C4.19635 21.793 3.77951 23.5662 3.52255 25.3911C0.742898 26.799 -2.03675 28.2069 -5.57063 28.2687C-5.57063 26.381 -5.57063 24.4933 -5.57063 22.6056Z"
              fill="#FFFFFF"
            />
            <path
              d="M5.18994 14.9793C8.75863 14.016 12.3274 13.0527 15.9507 13.0162C15.9507 14.4475 15.374 15.9407 14.6687 17.5167C11.09 17.5659 7.8195 18.8135 4.54897 20.0611C4.90157 18.3293 5.18994 16.6388 5.18994 14.9793Z"
              fill="#FFFFFF"
            />
            <path
              d="M4.54896 20.0612C7.81949 18.8135 11.09 17.5659 14.6687 17.5167C13.9634 19.0927 13.1297 20.7514 12.6158 22.5136C9.08187 22.5754 6.30221 23.9833 3.52255 25.3911C3.77951 23.5662 4.19635 21.793 4.54896 20.0612Z"
              fill="#FFFFFF"
            />
            <path
              d="M3.52255 25.3911C3.37527 26.4372 3.28055 27.5002 3.28055 28.5821C5.9127 27.1159 8.54484 25.6497 12.1317 25.6497C12.1317 24.5677 12.3212 23.5237 12.6158 22.5136C9.08187 22.5754 6.3022 23.9833 3.52255 25.3911Z"
              fill="#FFFFFF"
            />
            <path
              d="M-5.57063 31.5146C-3.42502 31.5146 -1.62104 30.9899 0.0456734 30.2545C0.0606937 31.9602 0.258316 33.9464 0.455937 35.9325C-1.45022 36.3003 -3.42502 36.5626 -5.57063 36.5626C-5.57063 34.8799 -5.57063 33.1972 -5.57063 31.5146Z"
              fill="#FFFFFF"
            />
            <path
              d="M-5.57063 36.5626C-3.42502 36.5626 -1.45022 36.3003 0.455938 35.9326C0.653559 37.9188 0.851181 39.9049 0.866202 41.6107C-1.27941 41.6107 -3.42502 41.6107 -5.57063 41.6107C-5.57063 39.928 -5.57063 38.2453 -5.57063 36.5626Z"
              fill="#FFFFFF"
            />
            <path
              d="M0.0456543 30.2545C1.71237 29.519 3.2418 28.5728 4.83833 27.7295C4.86837 29.4583 5.46952 32.0642 6.07067 34.6701C4.1996 35.0917 2.36208 35.5649 0.455918 35.9326C0.258296 33.9464 0.0606748 31.9602 0.0456543 30.2545Z"
              fill="#FFFFFF"
            />
            <path
              d="M0.455902 35.9326C2.36206 35.5649 4.19959 35.0917 6.07065 34.6701C6.67181 37.276 7.27296 39.8819 7.303 41.6107C5.15739 41.6107 3.01178 41.6107 0.866166 41.6107C0.851145 39.9049 0.653524 37.9188 0.455902 35.9326Z"
              fill="#FFFFFF"
            />
            <path
              d="M4.83835 27.7295C6.98323 26.5966 9.24919 25.6497 12.1318 25.6497C12.1318 27.3324 13.0865 30.4813 14.0413 33.6302C11.1587 33.6302 8.58442 34.1037 6.07069 34.6701C5.46954 32.0642 4.86839 29.4583 4.83835 27.7295Z"
              fill="#FFFFFF"
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f"
          x="-7.57063"
          y="-6.76096"
          width="73.0611"
          height="50.3716"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur stdDeviation="1" result="effect1_foregroundBlur" />
        </filter>
        <clipPath id="clip0">
          <rect
            width="58"
            height="36"
            fill="#FFFFFF"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default React.memo(HeaderLogoMobile);
